import { Directive, Input, HostBinding } from '@angular/core';
import { DropdownService } from '../dropdown.service';


@Directive({
  selector: '[dropdownMenu]',
  exportAs: 'dropdown-menu'
})
export class DropdownMenuDirective {

  /**
   * Dropdown menu alignment
   * https://v4-alpha.getbootstrap.com/components/dropdowns/#menu-alignment
  */
  @HostBinding('class.dropdown-menu') dropownMenu: boolean = true;

  @HostBinding('class.dropdown-menu-right')
  @Input() alignmentRight: boolean = false;

  @HostBinding('class.dropdown-menu-style-dark')
  @Input() darkStyle: boolean = false;

  constructor(
    private dropdownService: DropdownService
  ) {}

}
